var watchlist = {
	createWatchlistAction: "Ajouter Liste",
	editWatchlistAction: "Modifier Liste",
	deleteWatchlistAction: "Supprimer Liste",
	addPosition: "Ajouter Position",
	deletePosition: "Supprimer Position",
	noWatchlistTitle: "Info",
	noWatchlistMessage: "Aucune liste n'a encore été créée. Veuillez cliquer sur le bouton Ajouter Liste et compléter le formulaire pour créer une liste.",
	showActions: "Afficher les actions"
};
var fr = {
	watchlist: watchlist
};

export { fr as default, watchlist };
